import axios from 'axios'

export const AdminCountryService = {
  fetchCountryList (fetchOnlyPublished) {
    if (fetchOnlyPublished > 0) {
      return axios.get(`/api/v1/countrylist/${fetchOnlyPublished}`)
    } else {
      return axios.get('/api/v1/countrylist')
    }
  },
  addCountryItem (data) {
    return axios.post(`/api/v1/addcountry`, JSON.stringify({
      name: data.name,
      abbreviation: data.abbreviation,
      code: data.code,
      status: data.status,
      userId: data.userId,
      adoption: data.adoption,
      adoptionId: data.adoptionId
    }))
  },
  editCountryItem (data) {
    return axios.post(`/api/v1/editcountry`, JSON.stringify({
      name: data.name,
      abbreviation: data.abbreviation,
      code: data.code,
      status: data.status,
      userId: data.userId,
      id: data.id,
      adoption: data.adoption,
      adoptionId: data.adoptionId
    }))
  },
  searchCountryList (data) {
    return axios.get(`/api/v1/countrylist/` + data.fstatus, {
      params: {
        countryId: data.countryId,
        isAdoptionAvailable: data.isAdoptionAvailable
      }
    })
  },
  validateDeleteCountryItem (Data) {
    return axios.delete(`/api/v1/deletecountry`, {
      data: Data
    })
  },
  deleteCountryItem (Data) {
    return axios.delete(`/api/v1/deletecountry`, {
      data: Data
    })
  },
  fetchCountryDetailsById (id) {
    let queryParams = '?'
    if (id > 0) {
      queryParams += `cId=${id}`
    }
    return axios.get(`/api/v1/country${queryParams}`)
  }
}
